module.exports = __webpack_public_path__ + "img/skill-shape-2.a0e1df3e.png";